import { WA_WINDOW } from '@ng-web-apis/common';
import { computed, inject, Injectable, Signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getAppAccessModeByUrl } from '@core/helpers';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppAccessMode } from './app-access.types';

@Injectable({
  providedIn: 'root',
})
// Хранит текущий режим доступа приложения и помогает guest-flow отличать public route от private.
export class AppAccessService {
  private readonly window = inject(WA_WINDOW);
  private readonly accessMode$$ = new BehaviorSubject<AppAccessMode>(
    this.getInitialAccessMode(),
  );
  readonly accessMode$ = this.accessMode$$.asObservable();
  private readonly accessModeSignal = toSignal(this.accessMode$, {
    initialValue: this.getInitialAccessMode(),
  });

  readonly $accessMode: Signal<AppAccessMode> = computed(() =>
    this.accessModeSignal(),
  );

  // Определяет стартовый режим доступа по URL, с которого приложение открылось.
  getInitialAccessMode(): AppAccessMode {
    return this.getAccessModeByUrl(this.window.location.pathname);
  }

  // Классифицирует любой URL приложения как public или private.
  getAccessModeByUrl(url: string): AppAccessMode {
    return getAppAccessModeByUrl(url);
  }

  // Обновляет текущий режим доступа после старта приложения или при навигации.
  setAccessMode(mode: AppAccessMode): void {
    this.accessMode$$.next(mode);
  }
}
